import {Component, Inject} from '@angular/core';
import {DynamicFormsAssignedUsersFilters} from "./dynamic-forms-assigned-users-filters.interface";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {UtilsService} from "../../shared/utils.service";
import {
  NetworkedAccountsSelectorComponent
} from "../../shared/networked-accounts-selector/networked-accounts-selector.component";

@Component({
  selector: 'app-dynamic-forms-assigned-users-filters',
  templateUrl: './dynamic-forms-assigned-users-filters.component.html',
  styleUrls: ['./dynamic-forms-assigned-users-filters.component.scss']
})
export class DynamicFormsAssignedUsersFiltersComponent {
// Define the filter options.
  filter_options: DynamicFormsAssignedUsersFilters = {
    account_ids: [],
    dynamic_form_status: ''
  };

  constructor(
    // public location: Location,
    public utils: UtilsService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<DynamicFormsAssignedUsersFiltersComponent>
  ) {
    // set a default type of nothing if no values are passed through
    if (typeof this.data['account_ids'] == 'undefined') {
      this.data['account_ids'] = [];
    }

    // set a default category of nothing if no values are passed through
    if (typeof this.data['dynamic_form_status'] == 'undefined') {
      this.data['dynamic_form_status'] = '';
    }
  }

  ngOnInit() {
    // The constructor makes sure the values are set and present.
    this.filter_options.account_ids = this.data['account_ids'];
    this.filter_options.dynamic_form_status = this.data['dynamic_form_status'];
  }

  /**
   * Open the networked accounts selector to allow the user to filter users by account.
   */
  onFilterByAccount() {
    // Open the networked accounts selector.
    this.utils.showComponentDialog(NetworkedAccountsSelectorComponent, {
      multiple: true,
      selected: this.filter_options.account_ids
    }, {
      width: '1200px'
    })
      .then((response: number[]) => {
        // The response is returning either an array of selected ids, undefined or an empty string.
        // Discard response if it is undefined or an empty string.
        if ( typeof response != 'undefined' && response ) {
          // Store the account ids before refreshing the list.
          this.filter_options.account_ids = response;
        }
      });
  }

  /**
   * Clear the filter options and send the response back.
   */
  onClearAndClose() {
    // Clear all filter options.
    this.filter_options.account_ids = [];
    this.filter_options.dynamic_form_status = '';

    this.onSaveAndClose();
  }

  /**
   * Close the dialog and send the selected options as the response.
   */
  onSaveAndClose() {
    this.dialogRef.close(this.filter_options);
  }
}
